import React, { useContext } from 'react';
import classNames from 'classnames';
import { ConfigContext } from '../config-provider/config-context';
import { getPrefixCls } from '../_utils/general';
var MenuDivider = function (props) {
    var customisedCls = props.prefixCls, className = props.className;
    var configContext = useContext(ConfigContext);
    var prefixCls = getPrefixCls('menu-divider', configContext.prefixCls, customisedCls);
    var cls = classNames(prefixCls, className);
    return React.createElement("li", { className: cls });
};
MenuDivider.displayName = 'MenuDivider';
export default MenuDivider;
//# sourceMappingURL=menu-divider.js.map